import { ACTIVE_CUSTOMER_DISPLAY, ENABLE_CUSTOMER_DISPLAY } from 'redux/types'

export const setActiveCustomerDisplay = payload => {
  return {
    type: ACTIVE_CUSTOMER_DISPLAY,
    payload,
  }
}

export const setEnabledCustomerDisplay = payload => {
  return {
    type: ENABLE_CUSTOMER_DISPLAY,
    payload,
  }
}
